
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("7QgcX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;

var $5b59f64a060ccca5$var$_jquery = $5b59f64a060ccca5$var$_interopRequireDefault((parcelRequire("jG4hL")));
function $5b59f64a060ccca5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $5b59f64a060ccca5$var$init = module.exports.init = function init() {
    var attempts = 0;
    /*--------------------------------------------------------------------------------------------------------------------------------------*/ /*  Fragen und Antworten per Ajax im Klapper -------------------------------------------------------------------------------------------*/ /*  Boostrap Collapsibles: Status (auf/zu) an Elternelement übergeben ------------------------------------------------------------------*/ /*--------------------------------------------------------------------------------------------------------------------------------------*/ (0, $5b59f64a060ccca5$var$_jquery["default"])(".collapse").on("show.bs.collapse", function(e) {
        (0, $5b59f64a060ccca5$var$_jquery["default"])(e.target).parents(".card").addClass("active");
    });
    (0, $5b59f64a060ccca5$var$_jquery["default"])(".collapse").on("hide.bs.collapse", function(e) {
        (0, $5b59f64a060ccca5$var$_jquery["default"])(e.target).parents(".card").removeClass("active");
    });
    var _whenComplete = function whenComplete() {
        if (attempts > 30) return;
        attempts += 1;
        if (document.readyState === "complete") setTimeout(function() {
            (0, $5b59f64a060ccca5$var$_jquery["default"])(".collapse").on("shown.bs.collapse", function(e) {
                var top = (0, $5b59f64a060ccca5$var$_jquery["default"])(e.target).offset().top - 140;
                setTimeout(function() {
                    (0, $5b59f64a060ccca5$var$_jquery["default"])("html,body").animate({
                        scrollTop: top
                    }, 500);
                }, 500);
            });
        }, 1000);
        else setTimeout(function() {
            _whenComplete();
        }, 400);
    };
    _whenComplete();
};

});


//# sourceMappingURL=collapse.module.0f3eec6b.js.map
